import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'form-row-wrapper',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    '.form-row-wrapper { display:flex; min-width: 100%; > formly-group { flex: 1}} ',
  ],
  template: ` <ng-container #fieldComponent></ng-container> `,
})
export class FormRowWrapperType extends FieldWrapper {
  @HostBinding('class')
  readonly cssClass = 'form-row-wrapper';
}
